import { render } from "./RetailerPageCMS.vue?vue&type=template&id=fccdfa8c"
import script from "../js/retailer-page-cms.js?vue&type=script&lang=js"
export * from "../js/retailer-page-cms.js?vue&type=script&lang=js"

import exportComponent from "/Users/mdmahamudurzamanbhuyan/Sites/localhost/disposhop_jars/dispo_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__